import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class GamePlayersDataProvider extends BaseDataProvider {
  async getOne(resource, params) {
    console.log(
      "GamePlayerDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            SeasonTeamGamePlayerByID(id:"${params.id}") {
              id
              sportCode
              football {
                id
                puntingYards

                passingCompletions
                passingCompletionPercentage
                passingAttempts
                passingInterceptions
                passingYards
                passingAverage
                passingTouchdowns

                rushingAttempts
                rushingYards
                rushingAverage
                rushingTouchdowns

                receptions
                receivingYards
                receivingAverage
                receivingTouchdowns

                fieldGoalAttempts
                fieldGoalsMade
                fieldGoalYards

                totalPoints
              }
              girlsvolleyball {
                id
                kills
                aces
                digs
                blocks
                assists
              }
              baseball {
                id
                homeRuns
                doubles
                triples
                isPitcher
              }
              basketball {
                id
                totalPoints
                rebounds
                threePointFieldGoals
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.SeasonTeamGamePlayerByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    console.log(
      "GamePlayersDataProvider.delete(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteSeasonTeamGamePlayerByID(${infoString})
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }

  async update(resource, params) {
    console.log(
      "GamePlayersDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.sportCode;
    if (objectInfo.football) {
      delete objectInfo.football.id;
      delete objectInfo.football.__typename;
    }
    if (objectInfo.girlsvolleyball) {
      delete objectInfo.girlsvolleyball.id;
      delete objectInfo.girlsvolleyball.__typename;
    }
    if (objectInfo.baseball) {
      delete objectInfo.baseball.id;
      delete objectInfo.baseball.__typename;
    }
    if (objectInfo.basketball) {
      delete objectInfo.basketball.id;
      delete objectInfo.basketball.__typename;
    }
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateSeasonTeamGamePlayer(${objectString}) {
              id
              sportCode
              football {
                id
                puntingYards

                passingCompletions
                passingCompletionPercentage
                passingAttempts
                passingInterceptions
                passingYards
                passingAverage
                passingTouchdowns

                rushingAttempts
                rushingYards
                rushingAverage
                rushingTouchdowns

                receptions
                receivingYards
                receivingAverage
                receivingTouchdowns

                fieldGoalAttempts
                fieldGoalsMade
                fieldGoalYards

                totalPoints
              }
              girlsvolleyball {
                id
                kills
                aces
                digs
                blocks
                assists
              }
              baseball {
                id
                homeRuns
                doubles
                triples
                isPitcher
              }
              basketball {
                id
                totalPoints
                rebounds
                threePointFieldGoals
              }
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateSeasonTeamGamePlayer };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getManyReference(resource, params) {
    console.log(
      "GamePlayersDataProvider.getManyReference(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    if (params.target === "school_sport_season_team_id")
      return this.getManyReferenceViaSeasonTeam(resource, params);
    if (params.target === "school_sport_season_team_game_id")
      return this.getManyReferenceViaTeamGame(resource, params);
    throw new Error("BAD TARGET");
  }

  async getManyReferenceViaTeamGame(resource, params) {
    // return all the players in a particular game based on the
    // side object (not the game id, the id of the side object)
    console.log(
      "GamePlayersDataProvider.getManyReferenceViaTeamGame(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            TeamGameByID(id:"${params.id}") {
              id
              players {
                id
                sportCode
                player {
                  id
                  jerseyNumber
                  position
                  person {
                    name
                  }
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(response);
      const data = response.data.TeamGameByID.players;
      return { data: data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  // TODO: this is just wrong, it needs to over to the games area,
  // and the target should be something like game_player_id or
  // something. but do that later, leave it here for now.
  async getManyReferenceViaSeasonTeam(resource, params) {
    console.log(
      "GamePlayersDataProvider.getManyReferenceViaSeasonTeam(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            SeasonTeamPlayerByID(id:"${params.id}") {
              id
              playerGames {
                id 
                sportCode
                teamGame {
                  id
                  game {
                    id
                    sportCode
                    seasonCode
                    gameDateString
                    home {
                      season {
                        team {
                          name
                          school {
                            name
                          }
                        }
                      }
                    }
                    away {
                      season {
                        team {
                          name
                          school {
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(response);
      const data = response.data.SeasonTeamPlayerByID.playerGames;
      return { data: data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }
}

export default GamePlayersDataProvider;
